import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PrivacyPolicy from "../components/PrivacyPolicy";
import Faq from "../components/Faq";
import Terms from "../components/Terms";
import ReactGA from "react-ga";

ReactGA.pageview(window.location.pathname + window.location.search);

const TabContent = () => {
  const location = useLocation();
  const pathname = location.pathname.split("/").pop();

  switch (pathname) {
    case "faq":
      return <Faq />;
    case "privacy-policy":
      return <PrivacyPolicy />;
    case "terms-and-conditions":
      return <Terms />;
    default:
      return null;
  }
};

const Tabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname.split("/").pop();

  const handleTabClick = (tab) => {
    navigate(`/sawa/${tab}`);
  };

  return (
    <div className="bg-gray-200 text-black min-h-screen p-6">
      <div className="container mx-auto">
        <div className="flex items-center mb-8">
          <div className="mr-4 bg-primary rounded-md px-4 md:px-6">
            <Link to="/">
              <img
                src="/images/logo.png"
                alt="Logo"
                className="h-16 w-12 md:h-20 md:w-14 object-contain"
              />
            </Link>
          </div>
          <nav className="bg-primary text-white p-2 md:p-4 rounded shadow flex-1">
            <ul className="flex space-x-1 md:space-x-4">
              <li>
                <button
                  className={`text-sm md:text-base px-2 md:px-4 py-2 ${
                    pathname === "faq"
                      ? "border-b-2 border-secondary text-secondary"
                      : ""
                  }`}
                  onClick={() => handleTabClick("faq")}
                >
                  FAQ
                </button>
              </li>
              <li>
                <button
                  className={`text-sm md:text-base px-2 md:px-4 py-2 ${
                    pathname === "privacy-policy"
                      ? "border-b-2 border-secondary text-secondary"
                      : ""
                  }`}
                  onClick={() => handleTabClick("privacy-policy")}
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  className={`text-sm md:text-base px-2 md:px-4 py-2 ${
                    pathname === "terms-and-conditions"
                      ? "border-b-2 border-secondary text-secondary"
                      : ""
                  }`}
                  onClick={() => handleTabClick("terms-and-conditions")}
                >
                  Terms and Conditions
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <div className="bg-white p-6 rounded shadow">
          <TabContent />
        </div>
      </div>
    </div>
  );
};

export default Tabs;
